document.addEventListener("DOMContentLoaded", () => {

    const searchField = document.querySelector('.search-field-train');
    const selectTrain = document.querySelector('.select-train');

    if (!searchField || !selectTrain) {
        return
    }

    let isSelectTrainVisible = false;
    searchField.addEventListener('click', function() {
        if (isSelectTrainVisible) {
            selectTrain.style.display = 'none';
            isSelectTrainVisible = false;
        } else {
            selectTrain.style.display = 'block';
            isSelectTrainVisible = true;
        }
    });
    searchField.addEventListener('keyup',function(){
        const filter = searchField.value.toUpperCase();
        const a = selectTrain.getElementsByTagName("a");
        for (let i = 0; i < a.length; i++) {
            txtValue = a[i].textContent || a[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              a[i].style.display = "";
            } else {
              a[i].style.display = "none";
            }
        }
        console.log(a);
    })
    
    // Hide dropdown when clicking outside
    document.addEventListener('click', function(event) {
        if (!event.target.classList.contains('search-field-train') && !event.target.closest('.select-train')) {
            selectTrain.style.display = 'none';
            isSelectTrainVisible = false;
        }
    });
})
